module.exports = __webpack_public_path__ + "static/media/pattern.cdc35b53.svg";